import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  mb15: {
    marginBottom: 15
  },
  message: {
    color: '#12253F',
    fontFamily: 'TTCommons',
    fontSize: 17,
    fontWeight: 600,
    letterSpacing: 0,
    lineHeight: '20px',
    margin: '90px 0px 15px 0px'
  }
});
